import useUser from 'hooks/useUser'

import { useUks } from 'lib/api/uks'

export function useIpfsNetworkEnabled() {
  const { isLoading, user } = useUser()
  // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
  const { data: ipfs } = useUks(['networkMethodsGet', user?.id, 'ipfs'], {
    revalidateOnFocus: false,
    shouldRetryOnError: true
  })
  const disabled = ipfs?.result?.disabled ?? true
  if (isLoading) {
    return false
  }
  return !disabled
}
